import React, { useEffect, useState, useContext  } from "react"
import Flatpickr from "react-flatpickr";

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import { CreateLanguageSetting, GetLanguageSettingById, UpdateLanguageSetting } from "services/api/module/LanguageSetting"
import ModalContext from "../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import Error401 from "components/Error401";

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE
const _routePermission = `language:setting`

const LanguageSettingTemplate = ({
  pageView = "create"
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? 'TH'
  const qMainId = qParams.id
  const navigate = useNavigate();

  const [list, setList] = useState([
    { id: 1, name: 'Item 1' },
    { id: 2, name: 'Item 2' },
    { id: 3, name: 'Item 3' },
    { id: 4, name: 'Item 4' }
  ]);

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    langName: Yup.string().max(255).required("Please Enter ชื่อภาษา"),
    // contentDetail: Yup.string().max(255).required("Please Enter รายละเอียด"),
    langKey: Yup.string().max(512).required("Please Enter ตัวย่อ"),

    // contentSeoTitle: Yup.string().required("Please Enter Meta Title"),
    // contentSeoKeyword: Yup.string().max(1024).required("Please Enter Meta keyword"),
    // contentSeoDescription: Yup.string().max(1024).required("Please Enter Meta Description"),
    contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),


  })
  

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    langName: "",
    langKey: "",
    langFlag: "",

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format('YYYY-MM-DD'),
    contentStatus: "active",


  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ LanguageSettingCreate ~ values:", values)
      const payload = {
        id: qMainId ? qMainId : undefined,
        contentId: values.contentId ? values.contentId: undefined,
        langId: qLang,
        langName: values.langName,
        // contentDetail: values.contentDetail,
        langKey: values.langKey,
        langFlag: values.langFlag,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {

        },

        contentAttachmentData: {
        }
      };
      console.log("🚀 ~ onSave ~ payload:", payload);

      if (pageView === "update") {
        API.fetchUpdateLanguageSetting(payload)
      } else {
        API.fetchCreateLanguageSetting(payload)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("langName", resData?.langName ?? "")
    // validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    validation.setFieldValue("langKey", resData?.langKey ?? "")
    validation.setFieldValue("langFlag", resData?.langFlag ?? "")
    
    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
    validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

  }

  const API = {
    fetchGetLanguageSettingById: async (payload) => {
      try {
          const response = await GetLanguageSettingById({ id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 200) {
            preFilInput(resData.data)
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
            title: "Alert",
            subTitle: "Something went wrong",
            content: "",
            onClose: () => {
            //  alert("onClose")
            },
        })
      }
    },
    fetchCreateLanguageSetting: async (payload) => {
      try {
          const response = await CreateLanguageSetting({ data: payload, lang: qLang })
          const resData = response.data
          if (resData.status == 201) {
            mAlert.info({
                title: "Alert",
                subTitle: "Created Data Success",
                content: "",
                onClose: () => {
                  navigate(`/language/setting/${qLang}`)
                },
            })
          }
      } catch (e) {
          console.log(e)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    },
    fetchUpdateLanguageSetting: async (payload) => {
      try {
          const response = await UpdateLanguageSetting({ data: payload, id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 202) {
              mAlert.info({
                  title: "Alert",
                  subTitle: "Update Data Success",
                  content: "",
                  onClose: () => {
                    navigate(`/language/setting/${qLang}`)
                  },
              })
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    }
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id : qMainId }
      API.fetchGetLanguageSettingById(payload)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title = `LanguageSetting | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: '10px',
    border: '1px solid black',
    margin: '5px',
    borderRadius: '8px',
    background: '#f9f9f9',
    transition: 'transform 0.2s ease, background-color 0.3s ease',
  };

  const mapValues = (list = []) => list.map(item => {
    const newObj = {
      attachmentId: item.attachmentId,
      sequence: item.sequence
    }
    return newObj
  })  
  
  if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
    return <Error401 />
  }

  return (
      <React.Fragment>
          <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumb */}
                <Breadcrumbs
                  title={`${PAGE_VIEW} LanguageSetting`}
                  breadcrumbItems={[
                    { title: "LanguageSetting", link: "" },
                    { title: PAGE_VIEW },
                  ]}
                />
    
                {/* Render Form */}
                <Row>
                  <Col className="col-12">
                  <FormikProvider value={validation}>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                      }}
                    >
                      <Row>
                          <Col className="col-8">
                            <Card>
                              <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                <i className='bx bx-cube-alt'></i> Information Box
                              </h5>
                              <CardBody>
                              <Row>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    ชื่อภาษา
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="langName"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="langName"
                                    
                                      onChange={(e) => {
                                        validation.setFieldValue("langName", e.target.value)
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.langName}
                                      invalid={validation.touched.langName && validation.errors.langName ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.langName && validation.errors.langName && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.langName}
                                        </FormFeedback>
                                      )
                                    }
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    ตัวย่อ
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="langKey"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="langKey"
                                      maxLength={3}
                                      onChange={(e) => {
                                        validation.setFieldValue("langKey", e.target.value)
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.langKey}
                                      invalid={validation.touched.langKey && validation.errors.langKey ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.langKey && validation.errors.langKey && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.langKey}
                                        </FormFeedback>
                                      )
                                    }
                                  </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    ลิ้งค์รูปธง
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="langFlag"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="langFlag"
                                      onChange={(e) => {
                                        validation.setFieldValue("langFlag", e.target.value)
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.langFlag}
                                      invalid={validation.touched.langFlag && validation.errors.langFlag ? true : false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.langFlag && validation.errors.langFlag && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.langFlag}
                                        </FormFeedback>
                                      )
                                    }
                                  </div>
                                </Col>
                              </Row>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col className="col-4">
                            <Card outline color="primary" className="border sticky-element">
                                <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                  <i className='bx bx-check'></i> Tools Box
                                </h5>
                                <CardBody>
                                  <Row>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Written at
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <InputGroup>
                                          <Flatpickr
                                            className="form-control d-block"
                                            options={{
                                              dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                            }}
                                            value={validation.values.contentUpdateDate  ?moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                            disabled={true}
                                          />
                                          <div className="input-group-append">
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary docs-datepicker-trigger"
                                              disabled
                                            >
                                              <i className="fa fa-calendar" aria-hidden="true"/>
                                            </button>
                                          </div>
                                        </InputGroup>
                                        {
                                          (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                          )
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                                <CardFooter>
                                  <Row>
                                      <Col className="text-start">
                                          <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/language/setting/${qLang}`)}>Back</Button> 
                                      </Col>
                                      <Col className="text-end">
                                        {pageView !== 'view' && (<Button type="submit" className="btn btn-success">Save</Button>)}
                                      </Col>
                                  </Row>
                                </CardFooter>
                            </Card>
                          </Col>
                          
                      </Row>
                    </Form>
                  </FormikProvider>
                  </Col>
                </Row>
            </Container>
          </div>
      </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(LanguageSettingTemplate)
